
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { cloneDeep } from "apollo-utilities";

import FormGroup from "@/components/form/FormGroup.vue";
import UserLocationsMultiselect from "@/components/autocompleteMultiselects/UserLocationsMultiselect.vue";
import TitlesMultiselect from "@/components/autocompleteMultiselects/TitlesMultiselect.vue";
import SkillsMultiselect from "@/components/autocompleteMultiselects/SkillsMultiselect.vue";
import InputRangeFilter from "@/components/filters/InputRangeFilter.vue";
import ProfileCountrySelect from "@/components/autocompleteMultiselects/ProfileCountrySelect.vue";
import UserCityMultiselect from "@/components/autocompleteMultiselects/UserCityMultiselect.vue";
import RegionInput from "@/components/autocompleteMultiselects/RegionInput.vue";

import ContractorAdditionalFilters from "@/entities/scheduler/additionalFiltersInterfaces/ContractorAdditionalFilters";
import contractorViewFiltersTemplate from "@/data/filtersTemplates/scheduler/contractorViewFiltersTemplate";
import  DateRange from "@/entities/scheduler/DateRange"
import moment from "moment";
import FormDateRangePicker from "@/components/form/FormDateRangePicker.vue";
import UiButton from "@/components/button/ui-button.vue";
@Component({
  components: {
    FormGroup,
    UserLocationsMultiselect,
    TitlesMultiselect,
    SkillsMultiselect,
    InputRangeFilter,
    UserCityMultiselect,
    ProfileCountrySelect,
    RegionInput,
    FormDateRangePicker,
    UiButton
  },
})
export default class ContractorScheduler extends Vue {
  @Prop({ type: Boolean, default: false }) readonly shouldClearFilters!: boolean;
  filterFields: ContractorAdditionalFilters = cloneDeep(contractorViewFiltersTemplate);

  created(): void {
    this.$emit("appliedFiltersChanged", this.numberOfAppliedFilters);
  }

//wip 3
    rangeStart: Date = new Date();
    rangeEnd: Date = moment(this.rangeStart).add(1, 'M').toDate();
//wip 3 end 
  @Watch("numberOfAppliedFilters", { immediate: true })
  appliedFiltersChanged() {
    this.$emit("appliedFiltersNumberChanged", this.numberOfAppliedFilters);
  }

  @Watch("shouldClearFilters", { immediate: true })
  handleClearFilters(value: boolean): void {
    if (value === true) {
      this.clearFilters();
      this.$emit("filtersReset");
    }
  }

  @Watch("dateRange")
  handleDateRange() {
    this.$emit("rangeStart", this.rangeStart)
    this.$emit("rangeEnd", this.rangeEnd)
  }

  @Watch("propToWatch")
    handlePropToWatchChange(): void {
    this.$emit("filtersChanged", {
      countries: this.countriesNames,
      states: this.statesNames,
      cities: this.citiesNames,
      titles: this.titleIds,
      skills: this.filterFields.skills,
      minRate: this.filterFields.minRate,
      maxRate: this.filterFields.maxRate
    })
  }

  get numberOfAppliedFilters(): any {
    const appliedFiltersQuantity = {
      countries: this.filterFields.countries.length ? 1 : 0,
      states: this.filterFields.states.length ? 1 : 0,
      cities: this.filterFields.cities.length ? 1 : 0,
      titles: this.filterFields.titles.length ? 1 : 0,
      skills: this.filterFields.skills.length ? 1 : 0,
      rate: this.filterFields.minRate || this.filterFields.maxRate ? 1 : 0,
    }

    return Object.values(appliedFiltersQuantity)
      .reduce((prevValue, curValue) => {
        return prevValue + curValue;
      }, 0);
  }

  get countriesNames(): string[] {
    return this.filterFields.countries.map((country) => country.name);
  }

  get statesNames(): string[] {
    return this.filterFields.states.map((state) => state.name);
  }

  get citiesNames(): string[] {
    return this.filterFields.cities.map((city) => city.name);
  }

  get titleIds(): string[] {
    return this.filterFields.titles.map(title => title.id);
  }
//wip 2 start 
  get dateRange(): DateRange {
    return {
      startDate: this.rangeStart,
      endDate: this.rangeEnd,
    }
  }
  //wip 2 close
//wip 4
    handleDateRangeChange(date: DateRange) {
      this.rangeStart = date.startDate;
      this.rangeEnd = date.endDate;
    }
// wip 4 end

  get propToWatch(): string {
    return JSON.stringify([
      this.filterFields.countries,
      this.filterFields.states,
      this.filterFields.cities,
      this.filterFields.skills,
      this.filterFields.titles,
      this.filterFields.minRate,
      this.filterFields.maxRate,
    ])
  }

  clearFilters(): void {
    this.filterFields = cloneDeep(contractorViewFiltersTemplate);
  }

  closeModal(): void{
    this.$emit('close')
  }
}
